import React from 'react';
import { useTranslation } from 'react-i18next';
import { Section } from '../ui/Section';
import { FEATURES } from '../../utils/constants';
import styles from './FeaturesList.module.css';

export const FeaturesList: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Section background="primary" padding="none">
        <h3 className={styles.sectionTitle}>{t('home.features.title')}</h3>
      </Section>
      <div className={styles.featureListContainer}>
        <ul className={styles.featureList}>
          {FEATURES.map((feature, index) => (
            <li key={index} className={styles.featureItem}>
              {feature}
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};
